export const TranslationsMS = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
        ms: 'Bahasa Melayu',
        ro: 'Română',
        cs: 'Čeština',
        hu: 'Magyar',
        ta: 'தமிழ்',
        te: 'తెలుగు',
        bn: 'বাংলা',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
        ms: 'MS',
        ro: 'RO',
        cs: 'CS',
        hu: 'HU',
        ta: 'TA',
        te: 'TE',
        bn: 'BN',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HIN',
        ko: 'KOR',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
        ms: 'MSA',
        ro: 'RON',
        cs: 'CES',
        hu: 'HUN',
        ta: 'TAM',
        te: 'TEL',
        bn: 'BEN',
    },
    // BASE
    phrases: {
        order_online: 'Pesanan Dalam Talian',
        cart: 'Troli',
        open_24: '24 Jam',
        closed: 'tertutup',
        free: 'PERCUMA',
        something_went_wrong: 'ada sesuatu yang tidak kena',
        try_again: 'cuba lagi',
    },
    constants: {
        calendar: {
            days: {
                monday: 'Isnin',
                tuesday: 'Selasa',
                wednesday: 'Rabu',
                thursday: 'Khamis',
                friday: 'Jumaat',
                saturday: 'Sabtu',
                sunday: 'Ahad',
            },
        },
        services: {
            pickup: 'Pickup',
            delivery: 'Penghantaran',
            dine_in: 'Makan-Makan',
            table_booking: 'Tempahan Meja',
        },
        payment: {
            method: {
                cash: 'Duit',
                card: 'Kad',
                stripe: 'Credit Card',
                paypal: 'PayPal',
                cardconnect: 'Credit Card',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Razor Pay',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Custom',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net'
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'Duit',
                card: 'Kad',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Razor Pay',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online'
            },
            status: {
                success: 'Kejayaan',
                pending: 'Belum selesai',
                error: 'ralat',
                refunded: 'Dipulangkan',
                refunding: 'Bayaran balik',
                partial_refunded: 'Dipulangkan Separa',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Alih keluar',
                drop_here: 'Letakkan fail anda di sini atau klik untuk memilih satu',
                accepts: 'Menerima {{fileTypes}} fail',
                errors: {
                    max_files: 'Maksimum {{number}} dibenarkan',
                    max_size: 'Saiz fail maksimum {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'Kedai ini sedang ditutup dan pesanan makan-makan tidak boleh dibuat. Anda boleh cuba memesan untuk tarikh dan masa yang lepas',
            },
            buttons: {
                order: {
                    book_order: 'Tempah Meja / Pesanan Dalam Talian',
                    order_online: 'Pesanan Dalam Talian',
                    book_table: 'Tempah Jadual',
                    order: 'Pesanan',
                    book: 'Buku',
                    cart: 'Troli',
                    restart: 'Mulakan semula',
                    closed: 'Kedai Tutup',
                    not_accepting: 'Tidak Menerima Pesanan',
                },
            },
        },
        modals: {
            auth: {
                login: 'Log masuk',
                register: 'Daftar',
                register_commence: 'teruskan',
                register_complete: 'Buat Akaun',
                register_confirmation_sent: 'Kod pengesahan telah dihantar ke alamat e-mel anda. Sila masukkan di bawah untuk meneruskan',
                register_confirmation_resent: 'Kod pengesahan telah dihantar semula, sila periksa spam atau mulakan semula proses',
                register_restart: 'Mulakan semula',
                register_resend_code: 'Hantar semula kod',
                register_confirmation_code_subject: 'Kod Pengesahan E-mel',
                register_confirmation_code_email: 'Kod pengesahan e-mel anda ialah {{confirmation_code}} (Tamat tempoh dalam 24 jam)',
                login_placeholder: 'E-mel',
                password_placeholder: 'Kata laluan',
                confirm_password_placeholder: 'Sahkan Kata Laluan',
                confirmation_code_placeholder: 'Kod Pengesahan E-mel',
                accept_terms: 'Terima Terma & Syarat',
                accept_terms_view: 'Lihat',
                login_facebook: 'Log masuk Dengan Facebook',
                login_google: 'Log masuk Dengan Google',
                benefits: 'Log masuk atau cipta akaun untuk menyimpan semua pesanan anda',
                logged_in: 'Berjaya Log Masuk',
                logged_out: 'Log Keluar',
                password_reset: {
                    init_button: 'Hantar Mel Tetapan Semula Kata Laluan',
                    init_success: 'Pautan tetapan semula kata laluan telah dihantar ke e-mel anda',
                    complete_button: 'Tetapkan Semula Kata Laluan',
                    complete_success: 'Kata laluan berjaya ditetapkan semula, log masuk dengan kata laluan baharu anda',
                    forgot_password_text: 'Terlupa kata laluan anda?',
                    forgot_password_link: 'Tetapkan semula kata laluan',
                    remember_password_text: 'Ingat kata laluan anda?',
                    remember_password_link: 'pergi balik',
                    invalid_title: 'Tetapan Semula Kata Laluan Tidak Sah',
                    invalid_description: 'Pautan tetapan semula kata laluan ini tidak sah, sebaliknya minta yang baharu',
                    invalid_link: 'Pergi Ke Log Masuk',
                    title: 'Tetapan Semula Kata Laluan',
                    description: 'Masukkan kata laluan baharu untuk akaun anda',
                },
                error_generic: 'Kesilapan telah berlaku, sila cuba lagi atau hubungi kami',
                error_accept_terms: 'Sila terima terma & syarat',
                error_password_length: 'Minimum 6 aksara untuk kata laluan',
                error_social: 'Kesilapan telah berlaku, cuba lagi atau hubungi kami',
                error_confirmation_code: 'Kod pengesahan tidak sah',
                error_invalid_code: 'Kod pengesahan tidak sah',
                error_exists: 'Pengguna sudah pun wujud',
                error_invalid_email_pass: 'Alamat e-mel atau kata laluan tidak sah',
                error_password_no_match: 'Kata laluan tidak sepadan antara satu sama lain',
                error_user_not_found: 'Tiada pengguna dengan alamat e-mel itu',
                error_invalid_email: 'Alamat e-mel tidak sah',
                error_invalid_reset_token: 'Pautan tetapan semula tidak sah, minta satu lagi',
            },
            booking: {
                form: {
                    name: 'Nama Penuh',
                    email: 'Alamat E-Mel',
                    phone: 'Nombor Telefon',
                    number_of_people: 'Bilangan Orang',
                    number_of_people_max: 'Bilangan Orang ({{max_people}} Maks)',
                    number_of_people_min: 'Bilangan Orang ({{min_people}} Min)',
                    number_of_people_max_min: 'Bilangan Orang (Antara {{min_people}} hingga {{max_people}})',
                    notes: 'Nota / Permintaan Khas',
                    submit: 'Hantar Permintaan Tempahan',
                    email_optional: '(pilihan)',
                    date: 'Tarikh',
                    duration: 'Tempoh',
                    seating: 'Masa tersedia',
                    number_of_guests: 'Bilangan tetamu',
                    notes_placeholder: 'Alahan, majlis, pilihan tempat duduk',
                    reserving: 'Menempah...',
                    reserve_table: 'Tempah meja',
                    please_choose_a_date_and_time: 'Sila pilih tarikh dan masa.',
                    invalid_people: 'Bilangan orang mestilah antara {{min}} dan {{max}}.',
                    party_size_max_fallback: 'maksimum yang dibenarkan',
                    loading_available_times: 'Memuatkan masa yang tersedia…',
                    select_a_date_to_see_available_times: 'Pilih tarikh untuk melihat masa yang tersedia.',
                    no_times_available_for_this_date: 'Tiada masa tersedia untuk tarikh ini. Sila pilih hari lain.',
                    shift: 'Syif',
                    service_times: 'Waktu perkhidmatan',
                    new_shift: 'Syif baharu',
                    time: 'masa',
                    times: 'masa',
                    unavailable: 'Tidak tersedia',
                    available: 'Tersedia',
                    required_name: 'Sila masukkan nama anda.',
                    required_phone: 'Sila masukkan nombor telefon anda.',
                    required_email: 'Sila masukkan e-mel anda.',
                    invalid_email: 'Sila masukkan e-mel yang sah.',
                    required_terms: 'Sila terima terma sebelum menempah.',
                    reservation_is_unavailable: 'Tempahan tidak tersedia.',
                    please_contact_the_restaurant_directly: 'Sila hubungi restoran secara terus.',
                    almost_done: 'Hampir siap',
                    your_details: 'Butiran anda',
                    tell_us_who_s_coming: 'Beritahu kami siapa yang datang supaya kami dapat mengesahkan tempahan anda.',
                    book_your_table: 'Tempah meja anda',
                    choose_a_time_that_works_for_you: 'Pilih masa yang sesuai untuk anda.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Hantar permintaan tempahan dan restoran akan uruskan selebihnya.',
                    select_date: 'Pilih tarikh',
                    standard: 'Standard',
                    minutes: 'minit',
                    next: 'Seterusnya →',
                    back: '← Kembali',
                    accept_terms: 'Saya menerima terma dan syarat.',
                    info_1: 'Anda akan menerima pemberitahuan e-mel apabila tempahan anda diterima atau ditolak',
                },
                errors: {
                    not_found: "Tempahan tidak wujud. Mungkin telah dihapus",
                    generic: 'Kesilapan telah berlaku, muat semula halaman atau hubungi kami',
                    something_went_wrong: 'Sesuatu telah berlaku',
                    accept_terms: 'Sila terima terma & syarat',
                    required_phone: 'Sila masukkan nombor telefon anda',
                    required_email: 'Sila masukkan e-mel anda',
                    required_zip: 'Sila masukkan poskod pengebilan anda',
                    required_name: 'Sila masukkan nama anda',
                    invalid_email: 'Sila masukkan alamat e-mel yang sah',
                    invalid_phone: 'Sila masukkan nombor telefon yang sah',
                    invalid_people: 'Bilangan orang tidak sah',
                    missing_custom_fields: 'Sila isi semua medan yang diperlukan.',
                    booking_capacity_threshold: 'Kami penuh untuk masa ini. Sila cuba masa lain.',
                    slot_unavailable: 'Kami penuh untuk bilangan orang ini. Sila cuba masa lain.',
                    booking_date_paused: 'Tempahan dijeda untuk tarikh ini. Sila pilih hari lain.',
                    invalid_table_assignment: 'Meja tersebut tidak muat untuk kumpulan anda. Sila pilih masa lain.',
                    exceeded_order_limit: 'Terlalu banyak permintaan tempahan. Sila cuba lagi kemudian.',
                    validation_failed_recaptcha_v3: 'Trafik luar biasa dikesan. Adakah anda menggunakan VPN? Selesaikan pengesahan di atas dan cuba lagi.',
                    validation_failed_recaptcha_v2: 'Tempahan tidak dapat dimulakan. Sila cuba lagi atau gunakan cara lain. Jika anda menggunakan VPN, cuba matikannya dahulu.',
                    booking_already_exists: 'Tempahan ini telah dihantar. Semak e-mel anda atau buka pautan tempahan.',
                    invalid_party_size: 'Sila pilih bilangan orang yang sah.',
                    invalid_request: 'Permintaan tidak sah. Sila muat semula halaman dan cuba lagi.',
                    table_booking_unavailable: 'Tempahan meja tidak tersedia.',
                },
            },
            cart: {
                title: 'Troli',
                proceed_to_checkout: 'Teruskan Ke Checkout',
                edit_dish: 'Sunting',
                remove_dish: 'Alih keluar',
                no_items_1: 'Tiada item dalam troli',
                no_items_2: 'Tambah beberapa dahulu untuk meneruskan',
                free_delivery_notice: 'Penghantaran percuma untuk pesanan melebihi {{value, currency}}',
                errors: {
                    min_order_promo: 'Nilai troli minimum {{value, currency}} diperlukan sebelum promosi ini digunakan',
                    min_order_delivery: 'Nilai troli minimum {{value, currency}} untuk penghantaran',
                },
                promo: {
                    heading: 'Kod Promosi',
                    placeholder: 'Masukkan kod promosi anda',
                    add: 'Tambah Kod',
                    title: 'Promosi {{name}} ditambahkan pada troli',
                    fixed_discount: '{{value, currency}} Mati',
                    percent_discount: 'Potongan {{value}}%.',
                    added_to_cart: 'Promosi ditambahkan pada troli',
                    errors: {
                        not_found: 'Promosi tidak ditemui',
                        disabled: 'Promosi dilumpuhkan',
                        not_available: 'Promo tidak tersedia buat masa ini',
                        not_eligible: 'Tidak layak untuk menggunakan kod promosi',
                        not_available_time: 'Promo tidak berlaku untuk kali ini',
                        logged_in_only: 'Mesti log masuk untuk menggunakan promo ini',
                        already_used: 'Anda telah pun menggunakan promo ini',
                        invalid: 'Promo ini tidak sah lagi',
                        invalid_service: 'Promo ini tidak sah untuk perkhidmatan pilihan anda',
                        later_only: 'Sah untuk pra-pesanan sahaja',
                        now_only: 'Sah hanya untuk pesanan yang perlu dibayar serta-merta bukan pra-pesanan',
                        generic: 'Op... berlaku kesilapan dan telah dilog',
                        dishes_required_multi: 'Promo ini hanya akan digunakan apabila item tertentu ditambahkan pada troli anda',
                        dishes_required_single: "This promo will only be applied for '{{dish}}'",
                    },
                },
                tip: {
                    title: 'Petua Pesanan',
                    placeholder: 'Tambah petua pesanan',
                },
            },
            free_items_promo: {
                title: 'Barang Percuma',
                usage_confirmation: {
                    question: 'Anda layak mendapat item percuma. Adakah anda ingin melihat dan menambahnya?',
                    cancellation: "Tidak, saya tidak mahu item percuma",
                    acceptance: 'ya',
                },
                free_items_selection: {
                    multiple: {
                        description: 'Pilih {{number}} item percuma',
                    },
                    single: {
                        description: 'Pilih item percuma',
                    },
                    confirm_button: 'sahkan',
                },
            },
            checkout: {
                title: 'Checkout',
                subtitle: 'Sahkan butiran pesanan anda',
                details: {
                    service: 'Perkhidmatan',
                    due: 'kena bayar',
                    due_now_asap: 'Sekarang / ASAP',
                    address: 'Alamat Penghantaran',
                    total: 'Jumlah',
                    table: 'Jadual',
                    store_location: 'Alamat Kedai',
                },
                customer: {
                    title: 'Pelanggan',
                    subtitle: 'Log masuk untuk menyimpan pesanan & butiran anda',
                    button: 'Log masuk',
                    name: 'Nama Penuh',
                    email: 'E-mel',
                    phone: 'telefon',
                    phone_important: 'Telefon (Penting)',
                    notes: 'Nota Pesanan',
                    delivery_notes: 'Arahan Penghantaran / Nota Pesanan',
                    optional: 'pilihan',
                },
                payment: {
                    title: 'Kaedah Pembayaran',
                    qr_modal_help: 'Gunakan aplikasi {{app}} mobile anda untuk memindai QR dan selesaikan pembayaran untuk pesanan ini. Setelah pembayaran selesai pada aplikasi mobile anda, anda boleh menutup modal QR ini. Sila jangan menutup modal QR ini jika anda belum selesai proses pembayaran anda.',
                    switch_to_app_help: 'Dengan menekan butang di bawah, aplikasi {{app}} mobile akan dibuka secara automatik untuk menyelesaikan pembayaran untuk pesanan ini. Setelah pembayaran selesai pada aplikasi mobile anda, anda boleh menutup modal ini. Sila jangan menutup modal ini jika anda belum selesai proses pembayaran anda.',
                    open_app: 'Buka Aplikasi {{app}}',
                    continue: 'teruskan',
                    continue_to_payment: 'Teruskan ke {{method}}',
                    back_to_cart: 'Kembali ke Troli',
                },
                accept_terms: 'Terima Terma & Syarat',
                accept_terms_view: 'Lihat',
                processing_order: 'Pesanan Pemprosesan',
                warning: {
                    different_payment_currency: 'Harga kedai adalah dalam {{store_currency}} tetapi kaedah pembayaran adalah dalam {{payment_currency}}',
                    closing_soon: 'Ditutup tidak lama lagi, pesanan mesti dibuat dalam masa {{value}} minit',
                    closed: 'Maaf, perkhidmatan ini telah ditutup dan pesanan tidak diterima',
                    paused: 'Maaf, perkhidmatan ini telah dijeda dan pesanan tidak diterima buat masa ini',
                    expired: 'Kami tidak lagi dapat memenuhi pesanan anda pada masa yang anda pilih. Sila pilih tarikh atau masa kemudian',
                },
                errors: {
                    walletly_promo: 'Promo Walletly ada ralat, sila cuba promo lain!',
                    stripe_generic: 'Ralat kad kredit, cuba lagi atau kaedah lain',
                    validation_failed: 'Bayaran ini tidak boleh diterima pada masa ini. Sila cuba sebentar lagi atau pilih kaedah pembayaran lain.',
                    validation_failed_recaptcha_v3: 'Trafik luar biasa dikesan. Adakah anda menggunakan VPN? Sila selesaikan cabaran di atas dan cuba lagi.',
                    validation_failed_recaptcha_v2: 'Kami tidak dapat memulakan pembayaran. Sila cuba lagi atau gunakan kaedah lain. Jika anda menggunakan VPN, cuba matikannya dahulu.',
                    stripe_loading_fail: 'Ralat memuatkan borang pembayaran, sila cuba lagi',
                    something_went_wrong: 'Sesuatu telah berlaku',
                    paypal_generic: 'Kesilapan telah berlaku dengan PayPal, cuba lagi atau pilih kaedah pembayaran lain',
                    payment_fail: 'Pembayaran gagal, sila cuba lagi atau pilih kaedah pembayaran lain',
                    payment_cancelled: 'Pembayaran dibatalkan, sila cuba lagi atau pilih kaedah pembayaran lain',
                    payment_error: 'Ralat memproses pembayaran dalam talian, cuba lagi atau pilih kaedah pembayaran lain',
                    payment_declined: 'Kaedah pembayaran anda telah ditolak',
                    card_declined: "Kad anda telah ditolak dan pembayaran tidak boleh diproses",
                    promo_max_uses_exceeded: "Kod promo ini telah mencapai had penggunaannya dan tidak lagi tersedia.",
                    store_closed: 'Kedai tutup dan tidak lagi menerima tempahan',
                    accept_terms: 'Sila terima terma & syarat',
                    required_payment: 'Sila pilih kaedah pembayaran',
                    required_phone: 'Sila masukkan nombor telefon anda',
                    required_email: 'Sila masukkan e-mel anda',
                    required_zip: 'Sila masukkan poskod pengebilan anda',
                    required_name: 'Sila masukkan nama anda',
                    invalid_email: 'Sila masukkan alamat e-mel yang sah',
                    invalid_phone: 'Sila masukkan nombor telefon yang sah',
                    invalid_cc_number: 'Nombor kad kredit anda tidak sah',
                    invalid_order_amount: 'Jumlah minimum yang diperlukan untuk kaedah pembayaran ini',
                    retry_cc_number: 'Kesilapan telah berlaku, masukkan semula nombor kad kredit anda dan cuba lagi',
                    closed: 'Kedai tutup dan tidak menerima tempahan',
                    promo_login_required: 'Mesti log masuk untuk menggunakan promo ini',
                    promo_used: 'Anda telah pun menggunakan promo ini',
                    promo_by_payment_method_not_applicable: 'Promo tidak terpakai pada kaedah pembayaran yang dipilih.',
                    missing_custom_checkout_fields: 'Sila isi semua medan yang diperlukan.',
                    delivery_unavailable: 'Perkhidmatan penghantaran mungkin tidak tersedia pada masa ini. Sila pertimbangkan untuk membuat pesanan Pick Up.',
                    required_delivery_provider: 'Sila pilih penghantaran perkhidmatan.',
                    required_delivery_quotation: 'Anggaran penghantaran tamat tempoh.',
                    exceeded_order_limit: 'Kami mendapat banyak pesanan pada masa ini. Sila pilih masa kemudian.',
                    exceeded_order_limit_later: 'Kami tidak lagi dapat memenuhi pesanan anda pada masa yang anda pilih. Sila pilih tarikh atau masa kemudian',
                },
                button: {
                    continue: 'Teruskan Ke Pembayaran',
                    place_order: 'Letakkan Pesanan',
                    update_order: 'Kemas kini Pesanan',
                },
                delivery_estimation: {
                    title: 'Anggaran Penghantaran',
                    details: {
                        provider: 'Pembekal Penghantaran',
                        estimated_fee: 'Anggaran Yuran',
                        estimated_total_fee: 'Jumlah Yuran Penghantaran',
                        estimated_discount_fee: 'Diskaun Yuran Penghantaran',
                        previous_estimated_fee: 'Anggaran Yuran Sebelumnya',
                        tips: 'Petua',
                        estimated_delivery_time: 'Anggaran Masa Penghantaran',
                        uber_new_estimation: 'Minta anggaran baharu',
                        uber_new_estimation_success: 'Anggaran Penghantaran Uber baharu digunakan.',
                        uber_estimation_expired: 'Anggaran penghantaran tamat tempoh',
                        uber_price: 'Kami memegang harga Uber',
                        uber_need_time: 'Saya perlukan lebih masa',
                        lalamove_price: 'Kami memegang kos penghantaran Lalamove',
                        lalamove_new_estimation_success: 'Anggaran Penghantaran Laalmove Baharu digunakan.',
                        lalamove_estimation_expired: 'Anggaran penghantaran tamat tempoh',
                        lalamove_need_time: 'Saya perlukan lebih masa',
                        lalamove_new_estimation: 'Minta anggaran baharu',
                    },
                    quotation_error: 'Kesilapan telah berlaku semasa mengira anggaran penghantaran.',
                },
            },
            customer: {
                age_v: {
                    title: 'Pengesahan Umur',
                    required_for_items: 'Diperlukan untuk memesan item tertentu',
                    min_age: 'Umur minimum: {{age}} tahun',
                    est_time: 'Anggaran masa pengesahan: {{time}} jam',
                    upload_description: 'Muat naik ID anda di bawah untuk pengesahan. Anda akan diberitahu melalui e-mel apabila disahkan. Muat naik sehingga 2 gambar dengan saiz maksimum 2 MB setiap satu',
                    pending_description_1: 'Terima kasih kerana membuatkan dokumen anda. Anda akan diberitahu melalui e-mel apabila disahkan',
                    pending_description_2: 'Muat semula halaman untuk mengemas kini status pengesahan. Masa pengesahan dianggarkan adalah {{time}} jam',
                    approved_description: 'Akaun anda telah disahkan dan anda boleh memesan dari menu terhad',
                    rejected_description: 'ID anda telah ditolak. Jika anda ingin mencuba lagi, sila muat naik semula ID anda',
                    upload: 'Muat naik',
                    reupload: 'Muat Naik Semula Dokumen',
                    go_back: 'Pergi Balik',
                    view_document: 'Lihat Dokumen {{number}}',
                    status: {
                        unverified: 'Tidak disahkan',
                        pending: 'Menunggu Kelulusan',
                        approved: 'Berjaya Disahkan',
                        rejected: 'ditolak',
                    },
                },
                headings: {
                    sessions: 'Sesi',
                    orders: 'Pesanan',
                    spend: 'Berbelanja',
                    order_history: 'Sejarah Pesanan',
                    loyalty: 'Kesetiaan',
                    loyalty_points: 'Mata Kesetiaan',
                    added: 'Promosi ditambah.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'Sila pilih mana-mana item sebelum menebus!',
                    not_found: 'Promosi tidak ditemui!',
                    already_exists: 'Promo sudah ada!',
                    try_again: 'Tidak boleh menggunakan perjanjian ini. Sila cuba lagi!',
                },
            },
            custom_payment: {
                title: '{{name}} Borang Pembayaran',
                description: 'Anda telah mencapai borang pembayaran dalam talian kami. Sila lengkapkan medan di bawah untuk membuat pembayaran. Jika amaun tidak dimasukkan, butiran anda akan disimpan tetapi anda tidak akan dikenakan caj.',
                disabled: 'Halaman pembayaran dalam talian ini tidak telah dikonfigurasi dengan betul. Sila hubungi pemilik laman untuk membetulkan masalah.',
                success: 'Pembayaran anda telah berjaya diproses dan butiran anda telah disimpan. terima kasih',
                back: 'Kembali Ke Rumah',
                fields: {
                    name: 'Nama Penuh',
                    email: 'Alamat E-mel',
                    reference: 'Ruj Pembayaran',
                    amount: 'Amaun ($)',
                    name_on_card: 'Nama Pada Kad',
                    submit: 'Hantar Bayaran',
                },
                warning: {
                    currency: 'Nota: Amaun pembayaran dalam {{actual}}, bukan {{default}}',
                },
                errors: {
                    generic: 'Kesilapan telah berlaku, cuba lagi atau hubungi kami',
                    stripe_generic: 'Ralat kad kredit, muat semula halaman dan cuba lagi',
                    payment_fail: 'Pembayaran gagal, sila cuba lagi atau pilih kaedah pembayaran lain',
                    payment_cancelled: 'Pembayaran dibatalkan, sila cuba lagi atau pilih kaedah pembayaran lain',
                    payment_error: 'Ralat memproses pembayaran dalam talian, cuba lagi atau pilih kaedah pembayaran lain',
                    payment_declined: 'Kaedah pembayaran anda telah ditolak',
                    card_declined: "Kad anda telah ditolak dan pembayaran tidak boleh diproses",
                    promo_max_uses_exceeded: "Kod promo ini telah mencapai had penggunaannya dan tidak lagi tersedia.",
                },
            },
            dish: {
                add: 'Tambah Ke Troli',
                edit: 'Kemas kini Item',
                notes: 'Arahan khas...',
                ingredients: {
                    title: 'bahan-bahan',
                    uncheck_remove: 'Nyahtanda untuk mengalih keluar',
                },
                ingredients_title: 'bahan-bahan',
                combo: {
                    choose_dish: 'Pilih Item',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Pilih satu (Diperlukan)',
                        select_one_optional: 'Pilih satu (Pilihan)',
                        select_between: 'Pilih antara {{min}} - {{max}} (Diperlukan)',
                        select_at_least: 'Pilih sekurang-kurangnya {{qty}} (Diperlukan)',
                        select_up_to: 'Pilih sehingga {{qty}} (Pilihan)',
                        select_multiple_optional: 'Pilih berbilang (Pilihan)',
                        select_multiple: 'Pilih berbilang (Diperlukan)',
                        free_amount: 'Pertama {{qty}} Percuma / {{selected}} Dipilih',
                    },
                    points: {
                        none_consumed: 'Anda boleh memilih maksimum {{maxFree}} pilihan secara percuma',
                        less_than_total_points: 'Anda boleh memilih lebih banyak pilihan secara percuma',
                        greather_than_total_points: 'Anda boleh memilih lebih banyak pilihan untuk caj tambahan',
                    },
                },
                error: 'Sila betulkan mana-mana pilihan yang ditandakan dengan warna merah',
                added_to_cart: 'Item Ditambah Pada Troli',
            },
            map: {
                zone_fee: 'Yuran Penghantaran',
                view_in_google: 'Lihat Dalam Peta Google',
            },
            portal_go_back: {
                title: 'Kembali Ke Carian Restoran?',
                description: 'Sebarang item dalam troli anda akan hilang',
                cancel: 'Batal',
                proceed: 'Pergi Balik',
            },
            order: {
                config: {
                    services: {
                        title: 'Pilih Perkhidmatan',
                        table_booking: 'Meja Buku',
                    },
                    address_custom: {
                        input_placeholder: 'Masukkan alamat anda',
                    },
                    address: {
                        input_placeholder: 'Cari Alamat Penghantaran Anda',
                        extras_placeholder: 'Nombor unit, nama bangunan, arahan penghantaran, dll...',
                        search_placeholder: 'Cari Alamat Anda',
                        search_input_placeholder: 'Taip untuk mencari',
                        no_address_found: 'Tiada alamat ditemui. Cuba taip lebih daripada 5 aksara',
                        not_found: 'Alamat penghantaran tidak ditemui atau sah, cuba lagi',
                        not_delivering: 'Kami tidak menghantar ke alamat ini pada masa ini',
                        not_in_range: 'Alamat anda tidak berada dalam lingkungan lokasi kedai kami',
                        not_in_zone: 'Alamat anda tidak berada dalam zon penghantaran yang aktif',
                        no_number: 'Alamat anda mesti mempunyai nombor jalan',
                        location_permission: 'Benarkan tapak web ini mengakses lokasi semasa anda?',
                        location_permission_warning: "Tidak dapat mengakses lokasi semasa anda. Sila aktifkan perkhidmatan lokasi pada peranti anda dan pelayar web. Berikut adalah beberapa rujukan:",
                        pick_location: 'Pilih Lokasi Anda',
                        pick_location_help_text: 'Seret penanda untuk memilih lokasi pada peta.',
                        use_current_location: 'Gunakan Lokasi Semasa',
                        locate_on_map: 'Cari pada Peta',
                    },
                    datetime: {
                        title: 'Bilakah Anda Ingin Pesanan Anda',
                        due_now: 'Sekarang',
                        due_later: 'Nanti',
                        service_not_available: 'Maaf, pada masa ini kami tidak menerima tempahan untuk {{service}}',
                        currently_closed: '{{service}} ditutup pada masa ini tetapi anda boleh memesan untuk kemudian',
                        due_unavailable: 'Tidak tersedia',
                        due_closed: 'tertutup',
                        select_date: 'Pilih Tarikh',
                        select_time: 'Pilih Masa',
                        select_order_date: 'Pilih Tarikh Pesanan Anda',
                        select_order_time: 'Pilih Masa Pesanan Anda',
                        select_order_date_time: 'Pilih Tarikh/Masa Pesanan Anda',
                        select_booking_date: 'Pilih Tarikh Tempahan Anda',
                        select_booking_time: 'Pilih Masa Tempahan Anda',
                        no_times_available: 'Tiada masa tersedia untuk dipilih',
                        date_today: '(Hari ini)',
                        date_closed: '(Ditutup)',
                        date_bookings_paused: '(Tempahan dijeda)',
                        time_slot_closed: 'tertutup',
                    },
                    number_of_people: {
                        placeholder: 'Bilangan Orang',
                    },
                    table: {
                        select: 'Pilih Jadual',
                        select_popup_title: 'Pilih Jadual Anda',
                        password: 'Kata Laluan Jadual',
                        password_warning: 'Masukkan kata laluan jadual anda untuk meneruskan',
                    },
                    warning: {
                        closed: 'Maaf, kami tutup / tidak menerima sebarang tempahan',
                        not_available: 'Maaf, pada masa ini kami tidak menerima sebarang tempahan',
                    },
                    eta: {
                        delivery: `Anggaran masa penghantaran adalah lebih kurang {{minutesToCustomer}} minit`,
                        pickup: `Pesanan akan siap dalam masa lebih kurang {{minutesToCustomer}} minit`,
                    },
                    start_button: 'Mulakan Pesanan',
                },
                history: {
                    invalid: 'Tidak layak untuk pesanan semula kerana beberapa item yang dipesan telah dimodifikasi atau tidak lagi tersedia',
                },
                reorder: {
                    title: 'Pesan Semula Pantas',
                    description: 'Tempah item dengan mudah dari pesanan anda sebelum ini',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Pesanan tidak ditemui, muat semula halaman dan cuba lagi',
                    booking_not_found: 'Tempahan tidak wujud. Ia mungkin telah dipadam',
                    generic: 'Kesilapan telah berlaku, muat semula halaman atau hubungi kami',
                },
                connection: {
                    connected: 'Kemas kini masa nyata',
                    connecting: 'Kemas kini masa nyata menyambung',
                    disconnected: 'Kemas kini masa nyata terputus sambungan',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Amaran',
                    title: 'Log keluar',
                    body: 'Log keluar akan mengalih keluar sebarang item yang telah ditambahkan pada troli anda',
                    cancel: 'Batal',
                    proceed: 'Teruskan',
                },
                order_restart: {
                    warning: 'Amaran',
                    title: 'Tukar Butiran Pesanan',
                    body: 'Menukar butiran pesanan anda akan mengalih keluar item dalam troli anda kerana item tertentu mungkin tidak tersedia',
                    cancel: 'Batal',
                    proceed: 'Teruskan',
                },
                order_expired: {
                    subtitle: 'penting',
                    title: 'Pesanan ditukar kepada tarikh akhir serta-merta',
                    description: 'Masa yang dipilih untuk pesanan anda sekarang tidak jauh dari tamat tempoh. Oleh itu, pesanan anda telah dimodifikasi untuk diselesaikan segera / segera',
                    button: 'Ok',
                },
                order_expiring: {
                    subtitle: 'penting',
                    title: 'Tarikh Akhir Pesanan Akan Luput Tidak Lama Lagi',
                    description: 'Pesanan anda mesti dibuat sebelum {{time, timeFromTimestamp}} jika tidak, pesanan anda tidak lagi sah',
                    button: 'Ok',
                },
                location_permission: {
                    cancel: 'Batal',
                    proceed: 'Teruskan',
                },
            },
            card_payment_authentication: {
                title: 'Pengesahan Pembayaran',
                note: 'Sila pastikan tetingkap ini terbuka sehingga anda menyelesaikan proses pengesahan daripada bank anda.',
            },
            maps: {
                cancel: 'Batal',
                use_location: 'Gunakan Lokasi',
            },
            app_refresh: {
                refresh: 'Segarkan semula',
                title: 'Refresh Store',
                description: 'Kedai kami telah mengalami pembaikan. Sila segarkan pelayar anda untuk mengakses versi terbaru. Setelah segarkan, anda mungkin perlu membuka semula troli anda untuk melanjutkan proses pembayaran.',
            },
        },
        sections: {
            nav_top: {
                guest: 'tetamu',
                login: 'Log masuk',
                login_signup: 'Log masuk / Daftar',
                logout: 'Log keluar',
            },
            menus: {
                info: {
                    no_menus: 'Pada masa ini tiada menu tersedia',
                    restrictions: 'Sekatan Menu',
                    not_available: 'Menu Tidak Tersedia',
                    unavailable: {
                        times: "Menu tidak tersedia, keperluan pesanan anda tidak sepadan dengan di bawah",
                        services: "Menu tidak tersedia, keperluan pesanan anda tidak sepadan dengan di bawah",
                        hours: 'Menu tidak tersedia, waktu pesanan anda tidak dalam masa menu ini tersedia',
                        pre_order: "Menu tidak tersedia, pesanan anda tidak sepadan dengan keperluan pra-pesanan",
                        age: 'Menu tidak tersedia, anda mesti log masuk dengan akaun yang disahkan umur untuk memesan dari menu ini',
                    },
                    services: {
                        title: 'Keperluan Pesanan',
                        pickup: 'pikap',
                        delivery: 'Hantaran',
                        dine_in: 'Makan Malam',
                    },
                    times: {
                        now: 'Tiada pra-pesanan',
                        later: 'Pre-order sahaja',
                    },
                    hours: {
                        title: 'Waktu Tersedia',
                    },
                    preorder: {
                        title: 'Keperluan Pra-Pesanan',
                        days_in_advance: 'Mesti memesan {{days}} hari lebih awal',
                        cutoff_time: 'Masa tamat hari terakhir pada {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'Terhad Umur',
                        approved: 'Akaun anda telah disahkan dan anda boleh memesan dari menu ini',
                        rejected: 'Memerlukan pengesahan umur untuk memesan. Buat akaun dan muat naik ID anda',
                    },
                },
                search: {
                    title: 'Terokai Item Menu',
                    no_result: 'Tiada yang kembali. Cuba istilah carian lain?',
                    placeholder: 'Apa yang anda cari?',
                },
            },
            category: {
                restrictions: 'Sekatan Kategori',
                not_available: 'Kategori Tidak Tersedia',
                unavailable: {
                    services: "Kategori tidak tersedia, keperluan pesanan anda tidak sepadan dengan di bawah",
                    hours: "Kategori tidak tersedia, masa pesanan anda tidak dalam masa kategori ini tersedia",
                },
            },
            info: {
                location: {
                    title: 'Lokasi',
                    view_map: 'Lihat Peta',
                    phone: 'telefon',
                },
                hours: {
                    title: 'Waktu Buka',
                    title_special: 'Waktu Buka Khas',
                },
                services: {
                    title: 'Perkhidmatan',
                    notes: 'Nota',
                    delivery: {
                        ranges: 'Julat Penghantaran',
                        zones: 'Zon Penghantaran',
                        view_zones: 'Lihat Zon Pada Peta',
                        fee: 'Yuran Penghantaran',
                        fee_short: 'Yuran',
                        fee_varies: 'Berbeza-beza, ditunjukkan dalam troli',
                        min_order: 'Pesanan Minimum',
                        min_order_short: 'Min. pesanan',
                        no_min_order: 'Tiada Pesanan Minimum',
                        free_amount: 'Jumlah Penghantaran Percuma',
                    },
                },
            },
            contact: {
                title: 'Hubungi Kami',
                name: 'Nama',
                email: 'E-mel',
                phone: 'Nombor Telefon',
                message: 'Masukkan mesej anda...',
                send: 'Hantar Mesej',
                success: 'Mesej anda telah berjaya dihantar',
                error: 'Kesilapan telah berlaku, cuba lagi atau kemudian',
            },
            footer: {
                powered_by: 'Dikuasakan Oleh',
                terms_and_conditions: 'Terma & Syarat',
                privacy: 'Dasar Privasi',
                cookie: 'Dasar Kuki',
            },
        },
        pages: {
            payment_completed: {
                title: 'Pembayaran anda telah diproses. Terima kasih atas pesanan anda!',
                subtitle: 'Maklumat pesanan telah dihantar ke alamat e-mel anda.',
                back_to_menu: 'Kembali ke Menu',
                close_tab: 'Tutup tab ini',
            },
            payment_failed: {
                title: 'Malangnya terdapat ralat semasa memproses pembayaran anda.',
                subtitle: '',
                back_to_menu: 'Kembali ke Menu',
                close_tab: 'Tutup tab ini',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Resit Tempahan',
            details: {
                datetime: 'Tempahan Untuk',
                number_of_people: 'Bilangan Orang',
                placed: 'diletakkan',
                updated: 'Kemas Kini Terakhir',
                notes: 'Nota',
                name: 'Nama',
                email: 'E-mel',
                phone: 'telefon',
                store_address: 'Alamat Kedai',
            },
            status_update: {
                title: 'Tempahan {{number}} Dikemas kini',
                body: 'Status tempahan anda telah dikemas kini kepada {{status}}',
            },
            email_common: {
                name: 'Nama: {{name}}',
                phone: 'Telefon: {{number}}',
                number_of_people: 'Bilangan Orang: {{number}}',
                date: 'Tarikh: {{date}}',
                time: 'Masa: {{time}}',
                location: 'Lokasi Kedai: {{name}}',
                notes: 'Nota: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'Tempahan Meja Baharu {{number}} Oleh {{name}}',
                powered_by: 'Dikuasakan Oleh {{name}}',
                overview: 'Permintaan Tempahan Meja Baharu',
                title: 'Tempahan Baharu Untuk {{name}}',
                subtitle: 'Nombor Tempahan {{number}}',
                description_confirmed: 'Tempahan telah disahkan secara automatik. Anda boleh batalkan melalui papan pemuka pentadbir dan pelanggan anda akan diberitahu melalui e-mel',
                description_unconfirmed: 'Sila sahkan atau batalkan tempahan melalui papan pemuka pentadbir',
                url_pre_text: 'Lihat dan kemas kini di',
            },
            email_new_booking_customer: {
                subject: 'Permintaan Tempahan Meja',
                powered_by: 'Dikuasakan Oleh {{name}}',
                overview: 'Permintaan Tempahan Meja Baharu',
                title: 'Terima Kasih Atas Tempahan Anda',
                subtitle: 'Nombor Tempahan {{number}}',
                description: '<b>Anda akan menerima e-mel lain apabila tempahan anda telah disahkan atau ditolak.</b><br>Sila hubungi kami untuk membuat sebarang perubahan kepada tempahan anda. Butiran tempahan anda adalah seperti berikut:',
                url_pre_text: 'Anda boleh melihat resit tempahan masa nyata anda di',
            },
            email_update_booking_customer: {
                subject_confirmed: 'Tempahan Meja Disahkan',
                subject_unconfirmed: 'Tempahan Meja Dibatalkan',
                powered_by: 'Dikuasakan Oleh {{name}}',
                overview: 'Permintaan Tempahan Meja',
                title_confirmed: 'Tempahan Disahkan',
                title_unconfirmed: 'Tempahan Dibatalkan',
                subtitle: 'Nombor Tempahan {{number}}',
                description_confirmed: 'Kami menanti kedatangan anda. Sila hubungi kami untuk meminta sebarang perubahan kepada tempahan anda',
                description_unconfirmed: 'Kami minta maaf untuk memberitahu anda bahawa permintaan tempahan anda tidak dapat diterima. Kami minta maaf untuk sebarang kesulitan yang disebabkan. Sila hubungi kami jika anda ada sebarang pertanyaan',
                url_pre_text: 'Anda boleh melihat resit tempahan masa nyata anda di',
            },
            email_status_update_customer: {
                subject: 'Tempahan #{{number}} – {{subjectLabel}}',
                body: 'Tempahan anda #{{number}} di {{store}} kini {{status}}.',
            },
            errors: {},
            status_warning: 'Kemas kini status tempahan ini dalam papan pemuka pentadbir anda dalam halaman tempahan',
        },
    },
    email_delayed_order: {
        subject: 'Pesanan #{{number}} – {{subjectLabel}}',
        header: 'Masa siap dikemas kini',
        title: 'Masa siap dikemas kini',
        order_number: 'Nombor Pesanan: {{number}}',
        description: 'Pesanan anda akan siap pada {{time}}.',
        order_time_updated_to: 'Masa pesanan anda telah dikemas kini.',
        powered_by: 'Dikuasakan Oleh {{name}}',
        button_text: 'Susunan Jejak',
        subject_label: 'Masa siap dikemas kini',
        subject_label_delivery: 'Masa penghantaran dikemas kini',
        body_ready: 'Pesanan anda akan siap pada {{time}}.',
        body_delivery: 'Pesanan anda akan dihantar pada {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Anggaran Masa Sedia',
            est_driver_pickup_time: 'Anggaran Masa Ambil Pemandu',
            est_delivery_time: 'Anggaran Masa Penghantaran',
            tab_details: 'Butiran',
            tab_dishes: 'barang',
            future_order: 'Pesanan Masa Depan',
            reprint: 'CETAKAN SEMULA',
            details: {
                order_no: 'Pesanan No.',
                status: 'Status',
                placed: 'diletakkan',
                due: 'kena bayar',
                due_asap: 'Sekarang / ASAP',
                last_updated: 'Kemas Kini Terakhir',
                total: 'Jumlah',
                type: 'taip',
                origin: 'asal usul',
                table: 'Jadual',
                number_of_people: 'Bilangan Orang',
                payment_method: 'Kaedah Pembayaran',
                payment_status: 'Status Pembayaran',
                payment_currency: 'Mata Wang Pembayaran',
                notes: 'Nota',
                name: 'Nama',
                email: 'E-mel',
                phone: 'telefon',
                distance: 'Jarak',
                driving_time: 'Masa Memandu',
                delivery_zone: 'Zon',
                delivery_address: 'Alamat Penghantaran',
                delivery_provider: 'Pembekal Penghantaran',
                delivery_tracking: 'Penjejakan Penghantaran',
                delivery_return_tracking: 'Penjejakan Kembali',
                delivery_tracking_link: 'Susunan Jejak',
                tookan_status: 'Status Tookan',
                tookan_status_failed_book: 'Gagal menempah penghantaran',
                tookan_status_failed_update: 'Gagal mengemas kini tempahan',
                tookan_status_success: 'Tempah untuk penghantaran',
                store_address: 'Alamat Kedai',
                destination: 'Destinasi',
                estimated_arrival_time: 'Anggarkan Masa Ketibaan',
                delivery_status: 'Status',
                delivery_track_your_order: 'Jejaki Pesanan Anda',
                delivery_text: 'Penghantaran',
                arrival_date: 'Tarikh Ketibaan',
            },
            dishes: {
                headings: {
                    quantity: 'Kuantiti',
                    item: 'item',
                    price: 'harga',
                },
                notes: 'Nota',
                remove_ingredients: 'Keluarkan Bahan',
            },
            status_update: {
                title: 'Pesanan {{number}} Dikemas kini',
                body: 'Status pesanan anda telah dikemas kini kepada {{status}}',
            },
            wait_time_update: {
                title: 'Pesanan {{number}} Dikemas kini',
                body: 'Masa tamat pesanan anda telah dikemas kini',
            },
            delivery_update: {
                title: 'Pesanan {{number}} Dikemas kini',
                body: 'Pesanan anda telah ditempah untuk penghantaran. Lihat pautan penjejakan masa nyata',
            },
            payment_status_update: {
                title: 'Pesanan {{number}} Dikemas kini',
                body: 'Status pembayaran pesanan anda telah dikemas kini.',
            },
            email_new_order_restaurant: {
                subject: 'Pesanan Baharu ({{number}}) - {{name}}',
                powered_by: 'Dikuasakan Oleh {{name}}',
                overview: 'Pemberitahuan Pesanan Baharu',
                title: 'Pesanan Baharu Dibuat Di {{name}}',
                subtitle: 'Nombor Pesanan {{number}}',
                description: 'Lihat butiran dan kemas kini melalui papan pemuka pentadbir anda',
                button_text: 'Susunan Jejak',
                track_delivery_button_text: 'Penjejakan Penghantaran',
            },
            email_new_order_customer: {
                subject: 'Resit Pesanan ({{number}})',
                powered_by: 'Dikuasakan Oleh {{name}}',
                overview: 'Pemberitahuan Pesanan Baharu',
                title: 'Pesanan Baharu Dibuat Di {{name}}',
                subtitle: 'Nombor Pesanan {{number}}',
                description: 'Lihat butiran dan kemas kini melalui resit dalam talian masa nyata anda',
                button_text: 'Susunan Jejak',
                track_delivery_button_text: 'Penjejakan Penghantaran',
            },
            email_order_completed_by_customer: {
                subject: 'Pesanan ({{number}}) Dilengkapkan oleh Pelanggan',
                powered_by: 'Dikuasakan Oleh {{name}}',
                overview: 'Pemberitahuan Selesai Pesanan',
                title: 'Pesanan Selesai Pada {{name}}',
                subtitle: 'Nombor Pesanan {{number}}',
                description: 'Lihat butiran dan kemas kini pesanan anda melalui papan pemuka anda atau menggunakan resit di',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) inc. dalam harga',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'Yuran Penghantaran',
            delivery_fee_offset: 'Diskaun Yuran Penghantaran',
            delivery_fee_total: 'Jumlah Yuran Penghantaran',
            promo: 'Diskaun: {{name}} ({{value, currency}} + {{percent}}% Diskaun)',
            promo_percent: 'Diskaun: {{name}} ({{percent}}%)',
            promo_fixed: 'Diskaun: {{name}}',
            promo_none: 'Diskaun: {{name}}',
            cart: 'Troli',
            tip: 'Petua pesanan',
            total: 'Jumlah',
        },
        status: {
            unconfirmed: 'Tidak Disahkan',
            awaiting_payment: 'Menunggu Pembayaran',
            confirmed: 'Disahkan',
            ready: 'sedia',
            on_route: 'Di Laluan',
            complete: 'lengkap',
            cancelled: 'Dibatalkan',
            seated: 'Duduk',
        },
        searching: {
            lalamove_search_placeholder: 'Cari pesanan mengikut ID penghantaran Lalamove',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'Tidak tersedia',
                },
            },
            dish: {
                no_stock: 'Habis Stok',
                not_available: 'Tidak Tersedia',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'Kod Pengesahan E-mel',
            register_confirmation_code_email: 'Kod pengesahan e-mel anda ialah {{confirmation_code}} (Tamat tempoh dalam 24 jam)',
            register_confirmation_code_email_onbehalf: 'Kod pengesahan e-mel anda adalah {{confirmation_code}} (Tamat tempoh dalam 24 jam). Ini adalah untuk alamat e-mel, {{email}}.',
        },
    },
};
//# sourceMappingURL=ms.js.map